import React from 'react';
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory'
import { uuid } from 'rt-sd-common/sgiCommon/sgiCommon'
import { addCtnCommonAttribute } from './SgiCtnComm';
import ReactEcharts from 'echarts-for-react';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { getConstByKey } from './sgiBaseComp/SgiCommon';

const defaultGetOption = () => {
    return {
        title: {
            text: 'xxx图表',
            x: 'center'
        },
        tooltip: {
            trigger: 'axis'
        },
        grid: {
            left: 10,
            right: 100,
            top: 10,
            bottom: 10,
            // height:"50%",
            containLabel: true
        },
        legend: {
            // orient: 'horizontal',
            // align: 'right',
            right: 'right',
            top: 30,
            data: [].map(d => d.name)
        },
        calculable: true,
        xAxis: [{
            type: 'category',
            data: ['1', '2', '3', '4', '5'],
            splitLine: {
                show: true
            },
        }],
        yAxis: [{
            type: 'value',
        }],
        series: []
    };
}


export default class SgiCommEcharts extends React.Component {

    //这个暂时不好用 以后在处理
    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            uuid: uuid(8),
            data: this.props.data || [],
            echartsProps: { style: { width: "100%", height: "100%" } },
            option: {},
            getOption: defaultGetOption
        };
    }

    /**
     * maker构建
     * @param {object} parentModule 
     * @param {object} moduleDesc       
     * @param {ObjFactory} objFct 
     * @param {string} type 
     */
    echarts_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        // 转换公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.echartsProps);
        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.echartsProps, this.state.option, parentModule, objFct, type);
    }

    /**
     * 属性转换
     * @param {object} moduleDesc 
     * @param {object} echartsProps 
     * @param {object} option 
     * @param {object} parentModule 
     * @param {ObjFactory} objFct 
     * @param {string} type 
     */
    AddAttribute(moduleDesc, echartsProps, option, parentModule, objFct, type) {

        // var text = moduleDesc.te;//公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
        // if (text) echartsTitleProps.title = text;

        // var ttlAlgn = moduleDesc.ttlAlgn; //form标题对齐方式
        // if (ttlAlgn) echartsTitleProps.style['text-align'] = ttlAlgn;

        // var isTtl = moduleDesc.isTtl; //form是否显示标题
        // if (!isTtl) {
        //     echartsTitleProps.style.display = "none";
        // } else {
        //     echartsTitleProps.style.display = undefined;
        // }
        // this.state.isTtl = !!isTtl;

        // // 是否card样式
        // const isCard = moduleDesc.isCard;
        // this.state.isCard = !!isCard;

        // var isScl = moduleDesc.isScl; //form是否可以滚动??没实现
        // //if(isScl) echartsBodyProps.style.display

        // if (type === 'tabs' || type == 'cos') {
        //     echartsTitleProps.style.display = "none";
        // }

        // 取data
        const bdInst = getConstByKey(this, moduleDesc.bdInst);
        this.state.insName = bdInst;
        if (bdInst && objFct) {
            this.state.data = objFct.get(bdInst) || [];
        }

        // 自定义option
        let getOption = moduleDesc.option;
        let $getOption;
        if (getOption) {
            try {
                $getOption = new Function("module", "data", "objFct", getOption);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            this.state.getOption = $getOption;
        }
    }

    refreshByData(data) {
        data = data || [];
        this.setState({ data, uuid: uuid(8) });
    }

    refresh = () => {
        this.loaded = false;
        this.state.uuid = uuid(8);
        this.setState({ loading: false });
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded) {
            //组装属性
            this.echarts_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        return (
            <ReactEcharts
                key={this.state.uuid}
                {...this.state.echartsProps}
                option={(type === "dnd") ? defaultGetOption() : this.state.getOption(this, this.state.data, objFct)}
            />
        )
    }

}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiCommEcharts.js